module.exports = __webpack_public_path__ + "img/battery-charging.fcd91313.svg";